// AVISO BLOQUEANTE — modal, nao toast.
//
// Existe porque toast some sozinho em 4s no canto da tela, e no caixa isso ja custou caro: a
// Rafaela conferiu a gaveta no sabado, o sistema avisou "o turno continua aberto" num texto
// discreto, ela nao viu, foi embora achando que tinha fechado — e na segunda o caixa dela estava
// travado. Mensagem sobre DINHEIRO tem que barrar a tela e exigir um clique.
//
// Regra de uso (decidida com o Ruan em 2026-07-20): ERRO e RECUSA usam este aviso; SUCESSO
// continua em toast. Sucesso que some e inofensivo — a acao funcionou e a tela ja mostra o
// resultado. Erro que some deixa a pessoa achando que deu certo.
//
// Espelha o ToastProvider de proposito (provider global + hook), pra a troca nos componentes ser
// so `toast.erro(x)` -> `aviso.erro(x)` sem mexer no JSX de cada tela.
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from './Modal';

interface AvisoCtx {
  /** Erro/recusa: abre modal que exige clique. Use no lugar de toast.erro. */
  erro: (mensagem: string, titulo?: string) => void;
}

const AvisoContext = createContext<AvisoCtx | null>(null);

interface AvisoAberto {
  mensagem: string;
  titulo: string;
}

export function AvisoProvider({ children }: { children: ReactNode }) {
  // Fila, nao slot unico: dois erros em sequencia (ex.: falha ao salvar + falha ao recarregar)
  // nao podem se sobrescrever — o segundo apagaria o primeiro antes de alguem ler.
  const [fila, setFila] = useState<AvisoAberto[]>([]);

  const erro = useCallback((mensagem: string, titulo = 'Não foi possível concluir') => {
    setFila((prev) => [...prev, { mensagem, titulo }]);
  }, []);

  const fechar = useCallback(() => setFila((prev) => prev.slice(1)), []);

  const valor = useMemo(() => ({ erro }), [erro]);
  const atual = fila[0];

  return (
    <AvisoContext.Provider value={valor}>
      {children}
      {atual && (
        <Modal
          aberto
          onFechar={fechar}
          titulo={atual.titulo}
          largura={460}
          compacto
          rodape={<button type="button" className="btn-primario" onClick={fechar}>Entendi</button>}
        >
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <AlertTriangle size={20} style={{ color: '#b91c1c', flexShrink: 0, marginTop: 1 }} />
            <span style={{ fontSize: 14, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{atual.mensagem}</span>
          </div>
          {fila.length > 1 && (
            <p style={{ fontSize: 12, color: 'var(--text-muted)', margin: '10px 0 0' }}>
              +{fila.length - 1} aviso(s) na fila.
            </p>
          )}
        </Modal>
      )}
    </AvisoContext.Provider>
  );
}

export function useAviso(): AvisoCtx {
  const ctx = useContext(AvisoContext);
  if (!ctx) throw new Error('useAviso fora de AvisoProvider');
  return ctx;
}
